import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store';
import { LANGS } from '../../i18n';
import './Navbar.css';
const NAV_ITEMS = [
  { path: '/',           label: 'nav.dashboard', icon: '🗺️' },
  { path: '/events',     label: 'nav.events',    icon: '📋' },
  { path: '/statistics', label: 'nav.stats',     icon: '📊' },
  { path: '/devices',    label: 'nav.devices',   icon: '📡' },
  { path: '/whitelist',  label: 'nav.whitelist', icon: '✅' },
  { path: '/zones',      label: 'nav.zones',     icon: '🔰' },
  { path: '/node',       label: 'nav.node',      icon: '⬡' },
  { path: '/integrate',  label: 'nav.integrate', icon: '🔌' },
  { path: '/settings',   label: 'nav.settings',  icon: '⚙️' },
];
export default function Navbar() {
  const { t, i18n } = useTranslation();
  const user          = useStore(s => s.user);
  const [cloudMode, setCloudMode] = React.useState("CHECKING");
  const [tokenDaysLeft, setTokenDaysLeft] = React.useState(null);
  const [tokenValid, setTokenValid] = React.useState(true);
  const [syncPending, setSyncPending] = React.useState(0);
  React.useEffect(() => {
    const poll = async () => { console.log("[NAV POLL] token:", !!localStorage.getItem("uav_token"));
      const token = localStorage.getItem("uav_token");
      if (!token) return;
      try {
        const r = await fetch("/graphql", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
          body: JSON.stringify({ query: "{ cloudStatus { mode tokenValid tokenDaysLeft syncPending nodesOffline } }" })
        });
        const j = await r.json();
        const cs = j && j.data && j.data.cloudStatus;
        if (cs) { setCloudMode(cs.mode); setTokenDaysLeft(cs.tokenDaysLeft); setTokenValid(cs.tokenValid); setSyncPending(cs.syncPending); }
      } catch(e) { console.error("cloudStatus err:", e); }
    };
    poll();
    const t = setInterval(poll, 5000);
    return () => clearInterval(t);
  }, []);
  const role = user?.role;
  const isSuper = role === 'SUPERADMIN';
  const isSiteUser = role === 'OPERATOR' || role === 'VIEWER';
  const canManage = isSuper || role === 'PARTNER_ADMIN';
  const canConsole = canManage || role === 'PARTNER_DISPATCHER';

  // Супер-Админ не работает в кабинете оператора — скрываем мониторинговые вкладки.
  const SUPER_HIDE = ['/events', '/statistics', '/devices', '/whitelist', '/zones'];
  // У оператора Node и Integrate перенесены внутрь Settings.
  const SITE_HIDE = ['/node', '/integrate'];
  const navItems = NAV_ITEMS.filter(i => {
    if (isSuper && SUPER_HIDE.includes(i.path)) return false;
    if (isSiteUser && SITE_HIDE.includes(i.path)) return false;
    return true;
  });
  if (isSuper) navItems.push({ path: '/world', label: 'nav.world', icon: '🌍' });
  if (canConsole) navItems.push({ path: '/console', label: 'nav.console', icon: '🛰️' });
  if (canManage) navItems.push({ path: '/management', label: 'nav.manage', icon: '🏢' });
  if (isSuper) navItems.push({ path: '/billing', label: 'nav.billing', icon: '💳' });
  const clearAuth = useStore(s => s.clearAuth);
  const navigate = useNavigate();
  const handleLogout = () => {
    clearAuth();
    navigate('/login');
  };
  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <img className="brand-logo" src={`${process.env.PUBLIC_URL}/login-shield.png`} alt="DroneDefender" />
        <span className="brand-text">DroneDefender</span>
        <span className="brand-version">v3.1</span>
      </div>
      <div className="navbar-cloud">
        <div className={`cloud-badge ${cloudMode === "AUTONOMOUS" ? "badge-autonomous" : cloudMode === "CHECKING" ? "badge-checking" : "badge-online"}`}>
          <span className="cloud-dot" />
          <span>{cloudMode === "AUTONOMOUS" ? t('status.autonomous') : cloudMode === "CHECKING" ? t('status.checking') : t('status.online')}</span>
        </div>
        {syncPending > 0 && <div className="sync-badge" title={syncPending + " events pending sync"}>{"⟳ " + syncPending}</div>}
        {tokenDaysLeft !== null && tokenDaysLeft <= 7 && <div className="token-warn">{"🔑 " + tokenDaysLeft + "d"}</div>}
        {!tokenValid && tokenDaysLeft !== null && <div className="token-expired">⛔ LICENSE</div>}
      </div>
      <div className="navbar-links">
        {navItems.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{t(item.label)}</span>
          </NavLink>
        ))}
      </div>
      <div className="navbar-user">
        <select
          className="lang-select"
          value={i18n.resolvedLanguage}
          onChange={e => i18n.changeLanguage(e.target.value)}
          title={t('common.language')}
        >
          {LANGS.map(l => <option key={l.code} value={l.code}>{l.label}</option>)}
        </select>
        <span className="user-name">{user?.username}</span>
        <span className="user-role">{user?.role}</span>
        <button className="logout-btn" onClick={handleLogout}>{t('common.signOut')}</button>
      </div>
    </nav>
  );
}
